document.addEventListener('DOMContentLoaded', function () {
    const rewardSliderCallBack = (e) => {
      
      e.stopPropagation();
      e.preventDefault();
      document.querySelector('.loyaltylion-redemption-widget-rewards')?.classList.toggle('hidden');
      e.target.getElementsByTagName('span')[0]?.classList.toggle('hidden');
      e.target.getElementsByTagName('span')[1]?.classList.toggle('hidden');
      e.target.getElementsByTagName('span')[2]?.classList.toggle('r-180-deg');

      const forwardArrow = document.querySelector('.loyaltylion-redemption-widget-container__cart-popup .lion-in-cart-rewards-widget__navigator--forward')
      const backArrow = document.querySelector('.loyaltylion-redemption-widget-container__cart-popup .lion-in-cart-rewards-widget__navigator--back')
      
      const cartForwardArrow = document.querySelector('.loyaltylion-redemption-widget-container__cart-items .lion-in-cart-rewards-widget__navigator--forward')
      const cartBackArrow = document.querySelector('.loyaltylion-redemption-widget-container__cart-items .lion-in-cart-rewards-widget__navigator--back')
 
      forwardArrow.innerHTML = `<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.5 0L3 5L0.5 10L1.7729 8.51743C2.5896 7.56621 3.47164 6.69426 4.41022 5.91028L5.5 5L4.41022 4.08972C3.47164 3.30574 2.5896 2.43379 1.7729 1.48257L0.5 0Z" fill="#3E2B2E"/>
      </svg>`
  
      backArrow.innerHTML = `<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.5 0L3 5L5.5 10L4.2271 8.51743C3.4104 7.56621 2.52836 6.69426 1.58978 5.91028L0.5 5L1.58978 4.08972C2.52836 3.30574 3.4104 2.43379 4.2271 1.48257L5.5 0Z" fill="#3E2B2E"/>
      </svg>`

      if (cartForwardArrow) {
        cartForwardArrow.innerHTML = `<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.5 0L3 5L0.5 10L1.7729 8.51743C2.5896 7.56621 3.47164 6.69426 4.41022 5.91028L5.5 5L4.41022 4.08972C3.47164 3.30574 2.5896 2.43379 1.7729 1.48257L0.5 0Z" fill="#3E2B2E"/>
        </svg>`
      }
      
      if (cartBackArrow) {
        cartBackArrow.innerHTML = `<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.5 0L3 5L5.5 10L4.2271 8.51743C3.4104 7.56621 2.52836 6.69426 1.58978 5.91028L0.5 5L1.58978 4.08972C2.52836 3.30574 3.4104 2.43379 4.2271 1.48257L5.5 0Z" fill="#3E2B2E"/>
        </svg>`
      }

      const slider = document.querySelector('.lion-in-cart-rewards-widget__rewards-slider')
      
      let itemCount = slider.childElementCount
      let dividedItemCount = itemCount / 2
      let floor = Math.floor(dividedItemCount)

      // will be used when rewards slider counter is implemented:

      // let counterTotal = document.querySelector('.loyaltylion-redemption-widget-rewards__counter-total')
      // counterTotal.innerHTML = `<span>${itemCount}</span>`

      // let counterCurrent = document.querySelector('.loyaltylion-redemption-widget-rewards__counter-current')
      // counterCurrent.innerHTML = `<span>${counter + 1}</span>`
      // forwardArrow.addEventListener("click", forwardArrowClick);
      // backArrow.addEventListener("click", backArrowClick);

      // function forwardArrowClick() {
      //     if (counter < itemCount) {
      //       counter++;
      //       counterCurrent.innerHTML = `<span>${counter + 1}</span>`
      //     }
      // }

      // function backArrowClick() {
      //   if (counter < itemCount && counter > 0) {
      //     counter--;
      //     counterCurrent.innerHTML = `<span>${counter + 1}</span>`
      //   }
      // }

      if (screen.width > 600 && cartForwardArrow && cartBackArrow) {
        cartForwardArrow.addEventListener("click", cartForwardArrowClick);
        cartBackArrow.addEventListener("click", cartBackArrowClick);

        function cartForwardArrowClick() {
          if (counter + 1 == floor || counter == floor) {
            cartForwardArrow.style.visibility = 'hidden';
          }
          if (counter < floor) {
            counter++;
          }
        }

        function cartBackArrowClick() {
          counter--;
          cartForwardArrow.style.visibility = 'visible'
        }
      }
    }

    [...document.querySelectorAll('.js-redeem-rewards-slider-toggle')]?.forEach(function(button) {
      button.addEventListener('click', rewardSliderCallBack);
    });
  })